import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import {
  exchangeBreezeSession,
  persistApisessionHandover,
  pickApiSessionFromSearchParams,
} from '../../../services/request/BreezeWealth';

/**
 * Register this path as Redirect URL in ICICI Breeze portal, e.g.
 * `http://127.0.0.1:3000/admin/icici-breeze/oauth` or production `https://whatzneu.com/admin/icici-breeze/oauth`.
 * ICICI returns `apisession` (lowercase) in the query after login.
 */
function readApiSessionFromLocation(): string {
  const fromQuery = pickApiSessionFromSearchParams(new URLSearchParams(window.location.search));
  if (fromQuery) return fromQuery;
  const hash = window.location.hash?.replace(/^#/, '') ?? '';
  if (hash) {
    return pickApiSessionFromSearchParams(new URLSearchParams(hash));
  }
  return '';
}

const BreezeOAuthCallback: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    async function run() {
      const raw = readApiSessionFromLocation();
      if (!raw) {
        navigate('/admin/icici-breeze?oauth=missing', { replace: true });
        return;
      }
      let decoded = raw;
      try {
        decoded = decodeURIComponent(raw.replace(/\+/g, '%20'));
      } catch {
        decoded = raw;
      }
      persistApisessionHandover(decoded);
      try {
        await exchangeBreezeSession(decoded);
        if (!cancelled) {
          navigate('/admin/icici-breeze?connected=1', { replace: true });
        }
      } catch {
        if (!cancelled) {
          navigate('/admin/icici-breeze?oauth_error=1', { replace: true });
        }
      }
    }

    void run();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <Box sx={{ p: 4, textAlign: 'center' }}>
      <CircularProgress sx={{ mb: 2 }} />
      <Typography variant="body2">Exchanging ICICI session and saving token on the server…</Typography>
    </Box>
  );
};

export default BreezeOAuthCallback;
